import type { PropsWithChildren } from 'react'

import { useIntersectionObserver } from 'usehooks-ts'

import {
  CardFooterStyled,
  type ICardFooterStyledProps,
} from './styles/CardFooterStyled'

interface ICardFooterProps extends ICardFooterStyledProps {
  className?: string
}

export const CardFooter = ({
  isSticky,
  className,
  children,
}: PropsWithChildren<ICardFooterProps>) => {
  const { isIntersecting: isFooterAtBottom, ref } = useIntersectionObserver()

  return (
    <>
      <CardFooterStyled
        className={className}
        isSticky={isSticky}
        hasBorder={isSticky && !isFooterAtBottom}
      >
        {children}
      </CardFooterStyled>
      {isSticky ? <div ref={ref} /> : null}
    </>
  )
}

CardFooter.displayName = 'CardFooter'
